var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "notification-container",
    class: {
      'notification-overlay': _vm.imageOverlay
    },
    style: {
      'background-color': _vm.colorOverlay
    }
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_vm._t("default")], 2), _vm.$slots.hasOwnProperty('button') ? _c('div', {
    staticClass: "notification-button"
  }, [_vm._t("button")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }